/* eslint-disable */
/**
 * 请求接口后 微处理
 */
export const fetchReset = {
  methods: {
    getDataResetDom() {
      this.$nextTick(() => {
        console.log('fetch data');
        window.scrollTo(0, 1);
        window.scrollTo(0, 0);
      });
    }
  }
};
